// extracted by mini-css-extract-plugin
export default {"container":"InventoryManagement_container__LEFWH","wrapperButton":"InventoryManagement_wrapperButton__eSMNC","box":"InventoryManagement_box__J7mul"};